export default class CreateSolutionMinorVersionRecordError extends Error {
}
